// Preserve the existing hours-based API; minute selections are fractional hours.
export const ticketSalesWindows = [...Array.from({length:10},(_,i)=>(i+1)*60),45,30,25,15,10,5].map(minutes => ({
  value: minutes / 60,
  label: minutes % 60 === 0 ? `${minutes/60} ${minutes === 60 ? "hour" : "hours"} before draw` : `${minutes} minutes before draw`
}));
export function ticketSalesWindowValue(hours) { return Math.round(Number(hours) * 60) / 60; }
